import type { Nullable, StringMap } from 'corgi-types';
import type { ResponsiveValue } from 'styled-system';

import { isObject } from './object';

export const calculateVisibleElements = (elements: HTMLElement[]) =>
  elements.filter(el => getComputedStyle(el).display !== 'none').length;

const mapResponsiveArray = <T, U>(
  array: Array<Nullable<T>>,
  callback: (value: T) => U
): Array<Nullable<U>> => array.map(value => (value !== null ? callback(value) : null));

const mapResponsiveObject = <T, U>(
  object: StringMap<T>,
  callback: (value: T) => U
): StringMap<U> => {
  const result = {};
  for (const [key, value] of Object.entries(object)) {
    result[key] = value !== null ? callback(value) : null;
  }

  return result;
};

export const mapResponsiveValue = <T, U>(
  responsiveValue: ResponsiveValue<T> | undefined,
  callback: (value: T) => U
): ResponsiveValue<U> => {
  if (Array.isArray(responsiveValue)) {
    return mapResponsiveArray(responsiveValue, callback);
  }
  if (isObject(responsiveValue)) {
    return mapResponsiveObject(responsiveValue, callback);
  }
  if (responsiveValue !== null) {
    return callback(responsiveValue);
  }

  return null;
};
